import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CommonService } from 'src/app/shared/common.service';
import { Global } from 'src/app/Global';
import { MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
@Component({
  selector: 'app-audit-trail',
  templateUrl: './audit-trail.component.html',
  styleUrls: ['./audit-trail.component.css'],
  // standalone:true,
  // imports:[MatDialogModule,MatPaginatorModule,MatTableModule]
})
export class AuditTrailComponent implements OnInit {

  /**************************************Properties Declaration**************************/
  displayedColumns = ['fieldName', 'oldValue', 'newValue', 'action', 'createdOn', 'createdBy'];
  dataSource: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  /*******************************************END**********************************/
  constructor(private _commonService: CommonService, private global: Global) { }

  ngOnInit() {
   
    this.ShowAuditDetails();
  }

  ShowAuditDetails() {
    this._commonService.GetAuditTrails(this.global.auditTrailId, this.global.auditTrailClass)
      .subscribe(stream => {
        debugger
        if (stream['RequestIsSuccess']) {
          this.dataSource = new MatTableDataSource(stream['lstAuditTrail']);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        } else {
          alert(stream['RequestMessage']);
        }
      });
  }

}
